import numeral from 'numeral';
import { FORMATS } from '@/services/constants/format';
import type { FormatterArgs } from '@/services/types/formatter';

export default ({ data, key, decimal = 2 }: FormatterArgs) => {
  const rawValue = data[key] || 0;

  return {
    kind: 'percent',
    text: numeral(rawValue).format(FORMATS[decimal]),
    columnKey: key,
    numericValue: Number(rawValue),
  };
};
